var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("collapsible-card", {
    attrs: {
      "collapse-id": "client-profile-campaigns",
      "store-path": "clientProfileCampaigns",
      "body-class": "client-profile-scroll-card pt-0 pb-3",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function (ref) {
          var collapsed = ref.collapsed
          return [
            _vm._v(
              "\n    " + _vm._s(_vm.$tc("global.doorr.campaign", 2)) + "\n    "
            ),
            !collapsed
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-row align-items-center right-inner-addon w-80 w-lg-auto",
                  },
                  [
                    _c("icon", {
                      attrs: { name: "search", "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchText,
                          expression: "searchText",
                        },
                      ],
                      staticClass: "form-control search-clients ignore-popover",
                      attrs: {
                        id: "search-campaigns",
                        type: "search",
                        placeholder: _vm.$t("campaigns.actions.searchFor"),
                        autocomplete: "off",
                        "data-lpignore": "true",
                      },
                      domProps: { value: _vm.searchText },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.searchText = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "d-none",
                        attrs: { for: "search-campaigns" },
                      },
                      [_vm._v(_vm._s(_vm.$t("campaigns.actions.searchFor")))]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loading
              ? _c("co-applicants-info-loader")
              : _vm.filteredCampaigns.length > 0
              ? _vm._l(_vm.filteredCampaigns, function (ref, index) {
                  var campaignId = ref.campaignId
                  var name = ref.name
                  var status = ref.status
                  var scheduledDate = ref.scheduledDate
                  var updatedAt = ref.updatedAt
                  var familyName = ref.familyName
                  var givenName = ref.givenName
                  var photoVersion = ref.photoVersion
                  var profilePhoto = ref.profilePhoto
                  var username = ref.username
                  return _c(
                    "div",
                    {
                      key: campaignId,
                      class: {
                        "mb-3": index !== _vm.filteredCampaigns.length - 1,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.right",
                              value: {
                                title: _vm.isOwner(username)
                                  ? ""
                                  : _vm.$t("campaigns.messages.youAreNotOwner"),
                              },
                              expression:
                                "{\n            title: isOwner(username)\n              ? ''\n              : $t('campaigns.messages.youAreNotOwner')\n          }",
                              modifiers: { right: true },
                            },
                          ],
                          staticClass: "d-inline-block",
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "text-primary bold btn-view-app",
                              class: { disabled: !_vm.isOwner(username) },
                              attrs: {
                                to: _vm.campaignDetailsLink(campaignId),
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "bold text-primary mb-0",
                                  staticStyle: { "font-size": "1.14rem" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(name) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _c("span", { staticClass: "bold text-capitalize" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.campaignsStatus[status].toLowerCase()
                              ) +
                              ":\n          "
                          ),
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$options.filters.formatDateHour(
                                status === "cancelled"
                                  ? updatedAt
                                  : scheduledDate
                              )
                            ) +
                            "\n          (" +
                            _vm._s(
                              _vm.$options.filters.formatTimeAgo(
                                status === "cancelled"
                                  ? updatedAt
                                  : scheduledDate
                              )
                            ) +
                            ")\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "mb-0" },
                        [
                          _c("span", { staticClass: "bold" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("global.actions.lastUpdate")) +
                                ": "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("refreshable-timeago", {
                            attrs: { date: updatedAt },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(
                            "profile-avatar",
                            _vm._b(
                              {
                                staticClass: "client-avatar mr-2",
                                staticStyle: {
                                  width: "1.5rem",
                                  height: "1.5rem",
                                },
                              },
                              "profile-avatar",
                              {
                                familyName: familyName,
                                givenName: givenName,
                                photoVersion: photoVersion,
                                profilePhoto: profilePhoto,
                                username: username,
                              },
                              false
                            )
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              _vm._s(givenName) + " " + _vm._s(familyName)
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  )
                })
              : _c(
                  "no-results",
                  {
                    attrs: {
                      "img-src": require("@Shared/assets/img/email.png"),
                      "img-class": "my-2",
                      "text-class": "regular text-light-gray",
                      "text-style": "",
                    },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("tables.messages.emptyCampaigns")) +
                        "\n    "
                    ),
                  ]
                ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }